import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../util/Rest';
import {DEBTOR} from '../../constants/MicroServiceConstants';
import {PATIENT_TYPE, ACCIDENT_TYPE} from '../../constants/Lookup';

const initialData = {
  patientInterActionData: {},
  dropDownData: {},
  patientInteractionStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'patientInteraction',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchPatientInterActionData: (state, action) => {
      state.patientInterActionData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      // state.successMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postPatientInteractionData: (state, action) => {
      state.patientInteractionStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetPatientInteraction: (state) => {
      state.patientInteractionStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
    },
    resetSuccess: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchPatientInterActionData,
  fetchDropDownData,
  postPatientInteractionData,
  fetchStart,
  resetPatientInteraction,
  resetSuccess,
  fetchError,
} = slice.actions;

export const fetchPatientInterAction = (accountNumber) => {
  return (dispatch) => {
    // http://65.0.39.33:9091/api/v1/debtor/find/patientenc/{accountNumber}
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [PATIENT_TYPE, ACCIDENT_TYPE],
      }),
      httpGet(`${DEBTOR}/find/patientenc/${accountNumber}`),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        const patientInterActionData = data && data[1] ? data[1] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(lookUpApiData?.lookUpApiData?.error));
        }
        if (
          patientInterActionData &&
          patientInterActionData.status &&
          patientInterActionData.status === 200
        ) {
          dispatch(fetchPatientInterActionData(patientInterActionData.response));
        } else {
          dispatch(fetchError(patientInterActionData?.patientInterActionData?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postPatientInteraction = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${DEBTOR}/save/patientenc`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postPatientInteractionData(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const SuccessMsg = () => {
  return (dispatch) => {
    dispatch(resetSuccess());
  };
};
export const resetPatientInteractionStatus = () => {
  return (dispatch) => {
    dispatch(resetPatientInteraction());
  };
};
